export default __webpack_public_path__ + "static/media/my_customer_voice_theme_upload.00e534c9.gif";